import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _RunCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M3 3v18M21 3v18M13 7.158 15.5 4 18 7.158M15.5 4v15M6 16.8 8.5 20l2.5-3.2M8.5 20V5" })));
}
const RunCustom = forwardRef(_RunCustom);
export { RunCustom };
